import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { updateSetting } from "../../../../stores/actions/settings.actions.types";
import MetaHead from "../../../Common/Metahead";
import SMSUpdatedModal from "../../../Modals/sms-update-modal";
import SMSAddModal from "../../../Modals/sms-add-modal";
import Delete from "../../../Modals/delete";
import { couponList } from "../../../../stores/actions/coupon.actions.types";

const formatDurationFromMinutes = (minutes) => {
  if (minutes % (24 * 60) === 0) {
    return `${minutes / (24 * 60)} Days`;
  } else if (minutes % 60 === 0) {
    return `${minutes / 60} Hours`;
  } else {
    return `${minutes} Minutes`;
  }
};

const SmsSettingsPage = ({
  setting,
  updateSetting,
  couponList,
  reload,
  setReload,
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedSms, setSelectedSms] = useState(null);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [couponOptions, setCoupons] = useState([]);

  useEffect(() => {
    getCouponList();
  }, [reload]);

  const getCouponList = () => {
    const callback = (data) => {
      if (data.success) {
        const { coupons } = data?.data;
        setCoupons(coupons);
      }
    };
    couponList({ callback, data: { all: true, couponType: "general" } });
  };

  const convertToMinutes = (value, unit) => {
    const val = parseInt(value);
    if (unit === "days") return val * 24 * 60;
    if (unit === "hours") return val * 60;
    return val;
  };

  const handleUpdateSubmit = (values) => {
    setUpdateLoading(true);

    const updatedValues = {
      ...values,
      value: convertToMinutes(values.value, values.unit),
    };

    updateSetting({
      data: {
        ...setting,
        abandonedCartSms: setting.abandonedCartSms.map((item) =>
          item.key === selectedSms.key ? updatedValues : item
        ),
      },
      callback: (data) => {
        if (data.success) {
          setReload(!reload);
          setEditModalOpen(false);
          setUpdateLoading(false);
        }
      },
    });
  };

  const handleAddSubmit = (values) => {
    setAddLoading(true);

    const updatedValues = {
      ...values,
      value: convertToMinutes(values.value, values.unit),
    };

    updateSetting({
      data: {
        ...setting,
        abandonedCartSms: [...setting.abandonedCartSms, updatedValues],
      },
      callback: (data) => {
        if (data.success) {
          setReload(!reload);
          setAddModalOpen(false);
          setAddLoading(false);
        }
      },
    });
  };

  const handleDeleteClick = () => {
    setDeleteLoading(true);
    updateSetting({
      data: {
        ...setting,
        abandonedCartSms: setting.abandonedCartSms.filter(
          (item) => item.key !== selectedSms.key
        ),
      },
      callback: (data) => {
        if (data.success) {
          setReload(!reload);
          setDeleteLoading(false);
          setDeleteModalOpen(false);
        }
      },
    });
  };

  return (
    <div className='mx-auto mt-6 p-6 bg-white shadow-lg rounded-2xl dark:bg-gray-800'>
      <MetaHead title={"SMS Management"} />
      <div className='flex justify-between items-center mb-6'>
        <h1 className='text-2xl font-bold'>Abandoned Cart SMS Settings</h1>
        <button
          onClick={() => setAddModalOpen(true)}
          className='bg-red-600 text-white py-1 px-3 rounded-md flex items-center gap-1'
        >
          <FaPlus /> Add SMS
        </button>
      </div>

      <div className='space-y-4'>
        {setting.abandonedCartSms.map((sms, index) => (
          <div
            key={index}
            className='p-2 border border-gray-200 dark:border-gray-700 rounded-xl flex justify-between items-start'
          >
            <div>
              <p>
                <strong>Title:</strong> {sms.key}
              </p>
              <p>
                <strong>Time:</strong>{" "}
                {formatDurationFromMinutes(sms.value, sms.unit)}
              </p>

              <p>
                <strong>Message:</strong> {sms.message}
              </p>
            </div>
            <div className='flex gap-2'>
              <button
                onClick={() => {
                  setSelectedSms(sms);
                  setEditModalOpen(true);
                }}
                className='bg-red-600 text-white py-1 px-3 rounded-md flex items-center gap-1'
              >
                <FaEdit />
              </button>
              <button
                onClick={() => {
                  setSelectedSms(sms);
                  setDeleteModalOpen(true);
                }}
                className='bg-red-600 text-white py-1 px-3 rounded-md flex items-center gap-1 hover:bg-gray-500'
              >
                <FaTrash />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Edit Modal */}
      <SMSUpdatedModal
        editModalOpen={editModalOpen}
        handleUpdateSubmit={handleUpdateSubmit}
        selectedSms={selectedSms}
        setEditModalOpen={setEditModalOpen}
        updateLoading={updateLoading}
        couponOptions={couponOptions}
      />

      {/* Add Modal */}
      <SMSAddModal
        addLoading={addLoading}
        addModalOpen={addModalOpen}
        handleAddSubmit={handleAddSubmit}
        setAddModalOpen={setAddModalOpen}
        couponOptions={couponOptions}
      />
      {/* Delete Modal */}
      <Delete
        opened={deleteModalOpen}
        setOpend={setDeleteModalOpen}
        title='SMS Delete'
        handleDelete={handleDeleteClick}
        loading={deleteLoading}
      />
    </div>
  );
};

// Helper component for form fields

const mapStateToProps = (state) => ({
  loading: state.app.visible,
});

export default connect(mapStateToProps, {
  updateSetting,
  couponList,
})(SmsSettingsPage);
